import axios from 'axios'
import { API_CONFIG } from '../config'

class ApiClient {
  constructor() {
    this.baseUrl = API_CONFIG.baseUrl
  }
  configInterceptors() {
    let headers = this.getHeaders()
    this.axios.interceptors.request.use(
      config => {
        config.headers = headers
        return config
      },
      err => {
        return Promise.reject(err)
      }
    )

    this.axios.interceptors.response.use(
      response => {
        return response
      },
      err => {
        Promise.reject(err)
      }
    )
  }

  getHeaders() {
    let accessToken = localStorage.getItem('accessToken')
    if (accessToken) {
      return { Authorization: `Bearer ${localStorage.getItem('accessToken')}` }
    }
    return {}
  }

  setAccessToken(token) {
    this.axios.defaults.headers.common.Authorization = `Bearer ${token}`
  }

  post(endpoint, useHeaders, payload) {
    return axios({
      method: 'post',
      url: this.baseUrl + endpoint,
      headers: useHeaders ? this.getHeaders() : {},
      data: payload
    })
  }

  get(endpoint, useHeaders) {
    return axios({
      method: 'get',
      url: this.baseUrl + endpoint,
      headers: useHeaders ? this.getHeaders() : {}
    })
  }

  put(endpoint, useHeaders, payload) {
    return axios({
      method: 'put',
      url: this.baseUrl + endpoint,
      headers: useHeaders ? this.getHeaders() : {},
      data: payload
    })
  }

  /*
  for this method, you have to define a headers
  and the headers will have values from `getHeaders`
   */
  customPost(endpoint, header, payload) {
    const headers = Object.assign({}, this.getHeaders(), header)
    return axios({
      method: 'post',
      // url: this.baseUrl + endpoint,
      url: endpoint,
      headers,
      data: payload
    })
  }
}

export default new ApiClient()
